<template>
    
        <Navbar></Navbar>
        <h3 class="text-center mt-2 mb-5"> Atualizar Dados Pessoais </h3>
    <div class="container">
        <form>
            <div class="mb-3">
                <label for="celular" class="form-label">Celular *</label>
                <input v-if="verificarCelular()" type="text" v-mask="['#', '(##) #####-####']" class="form-control" id="celular" placeholder="Ex: (44) 98765-4321" :value="this.dadosPessoaisObj.celular" required>
                <input v-else type="tel" v-mask="['#', '(##) #####-####']" class="form-control" id="celular" placeholder="Ex: (44) 98765-4321" required>
            </div>
            <div class="mb-3">
                <label v-if="verificarDataNascimento()" for="dataNascimento" class="form-label">Data de Nascimento *</label>
                <input type="date" class="form-control" id="data_nascimento" :value="this.dadosPessoaisObj.data_nascimento.substring(0,10)" required>
            </div>
           <div class="mb-4">
                <a>Sexo *</a>
                <select class="form-select mt-1" aria-label="Sexo" id="sexo">
                    <option v-if="dadosPessoaisObj.sexo === 'null'" :selected="dadosPessoaisObj.sexo === 'null'" value=''>Selecione um sexo</option>
                    <option :selected="dadosPessoaisObj.sexo === 'M'" value="M">Masculino</option>
                    <option :selected="dadosPessoaisObj.sexo === 'F'" value="F">Feminino</option>
                    <option :selected="dadosPessoaisObj.sexo === 'O'" value="O">Outro</option>
                </select>
            </div>
            <button type="submit" class="btn btn-primary" v-on:click='submit()'>Atualizar Dados</button>
        </form>
    </div>
</template>

<script>

    import Navbar from '../components/Navbar.vue'
    import APIv3 from '../services/apiv3-endpoints'

    export default {
            name: 'DadosPessoais',
            components: {
                Navbar        
            },

            data() {
                return {
                    dadosPessoaisObj: {
                        celular: localStorage.getItem('celular'),
                        data_nascimento: localStorage.getItem('data_nascimento'),
                        sexo: localStorage.getItem('sexo'),
                    },
                }
            }, 

        methods: {
            
            verificarCelular() {
                if (this.dadosPessoaisObj.celular === null) {
                    return false
                } 
                else {
                    return true
                }

            },

            verificarDataNascimento () {
                if  (this.dadosPessoaisObj.data_nascimento === null) {
                    return false
                }
                else {
                    return true
                }
            },

            verificarMaioridade() {
                let data_nascimento = document.getElementById('data_nascimento').value
                data_nascimento = data_nascimento.substring(0,10)
                data_nascimento = data_nascimento.replace(/[^0-9]+/g, "/")
                let dataDeHoje = new Date()
                let dataDeNascimento = new Date(data_nascimento)

                // Ano atual - Ano da data de nascimento
                let idade = dataDeHoje.getFullYear() - data_nascimento.substring(0,4)

                //Mes Atual - Mes da data de nascimento
                let diferencaMes = (dataDeHoje.getMonth() + 1) - data_nascimento.substring(5,7)

                if (diferencaMes < 0 || (diferencaMes === 0 && dataDeNascimento.getDate() > dataDeHoje.getDate())) {
                    idade--
                }

                return idade            
            },

            atualizarDadosPessoais(obj) {
                APIv3.postDadosPessoais(obj)
            },

            submit() {
                let id = localStorage.getItem("idUsuario")
                let celular = document.getElementById('celular').value
                let data_nascimento = document.getElementById("data_nascimento").value
                let sexo = document.getElementById("sexo").value
                celular = celular.replace(/[^0-9]+/g, "")

                const dadosPessoais = {
                    id: id,
                    celular: celular,
                    data_nascimento: data_nascimento,
                    sexo: sexo,
                }
                
                sessionStorage.tempDataNascimento = data_nascimento
                sessionStorage.tempCelular = celular

                const listaDDDValido = ["68", "82", "92", "97", "96", "71", "73", "74", "75", "77", "85", "88", "61", "27", "28", "62", "64", "98", "99", "31", "32", "33", "34", "35", "37", "38", "67", "65", "66", "91", "93", "94", "83", "81", "87", "86", "89", "41", "42", "43", "44", "45", "46", "21", "22", "24", "84", "69", "95", "51", "53", "54", "55", "47", "48", "49", "79", "11", "12", "13", "14", "15", "16", "17", "18", "19", "63"]
                const DDD = dadosPessoais.celular.substring(0,2)

                this.dadosPessoaisObj.celular = sessionStorage.getItem('tempCelular')
                this.dadosPessoaisObj.data_nascimento = sessionStorage.getItem('tempDataNascimento')

                if (dadosPessoais.celular === "" || dadosPessoais.sexo === "" || dadosPessoais.data_nascimento === "") {
                    this.$swal.fire({
                        title: 'Você precisa inserir todos os dados obrigatórios *',
                        icon: 'warning',
                    })
                }

                else if (dadosPessoais.celular.length < 11 || dadosPessoais.celular.substring(2, 3) !== '9') {
                    console.log(this.dataNascimentoCadastrada)
                    this.$swal.fire({
                        title: 'Número de celular inválido!',
                        icon: 'warning',
                    })
                }

                else if (!listaDDDValido.includes(DDD)) {                   
                    this.$swal.fire({
                        title: 'Insira um DDD válido!',
                        icon: 'warning',
                    })
                }
                
                else if (this.verificarMaioridade() < 18) {   
                    this.$swal.fire ({
                        title: 'Atualização não permitida!',
                        text: 'Não é permitido menores de 18 anos.',
                        icon: 'warning'
                    })
                }

                else {
                    try {
                        this.atualizarDadosPessoais(dadosPessoais)
                        this.$swal.fire({
                            title: 'Dados atualizados com sucesso!',
                            icon: 'success',
                            allowOutsideClick: false
                        })
                        .then (result => {
                            if(result.isConfirmed) {
                                this.$router.push('/Home')
                            }
                        })
                    } 
                    catch (err) {
                        this.$swal.fire({
                            title: 'Ocorreu um erro na atualização dos dados!',
                            icon: 'error',
                            allowOutsideClick: false
                        })
                        console.log(err)
                    }
                }
            },
        }
    }

</script>